import React from "react";
// Import link
import { Link } from "react-router-dom";
// Import Social Icom
import facebook from "../../assets/img/icon/facebook.png";
import instagram from "../../assets/img/icon/instagram.png";
import twitter from "../../assets/img/icon/twitter.png";
import linkedin from "../../assets/img/icon/linkedin.png";
import tag from "../../assets/img/icon/tag.png";
import map from "../../assets/img/icon/map.png";
import cal from "../../assets/img/icon/cal.png";
// Import Img
import Organize from "../../assets/img/sidebar/project_organizer.png"
import img1 from "../../assets/img/sidebar/rec-cas-1.png";
import img2 from "../../assets/img/sidebar/rec-cas-2.png";
import img3 from "../../assets/img/sidebar/rec-cas-3.png";
import img4 from "../../assets/img/sidebar/rec-cas-4.png";

const NewsSidebar = () => {
  const ReceData = [
    {
      img: img1,
      title: `Badminton ladder & hall schedule`,
      date: "See latest email",
    },
    {
      img: img2,
      title: `Integration evening — schools`,
      date: "Events",
    },
    {
      img: img3,
      title: `Seasonal swim block opens`,
      date: "News",
    },
    {
      img: img4,
      title: `Family day — culture & sport`,
      date: "Save the date",
    },
  ];

  return (
    <>
      <div class="col-lg-4">
        <div class="sidebar_first">
          <div class="project_organizer_wrapper sidebar_boxed">
            <div class="project_organizer_img">
              <img src={Organize} alt="img" />
            </div>
            <div class="project_organizer_text">
              <h5>From:</h5>
              <h3>PCF communications</h3>
              <p>Pakistani Cultural &amp; Sports Organisation</p>
              <ul>
                <li>
                  <img src={tag} alt="icon" /> Topics:
                  <span>Badminton &amp; integration</span>
                </li>
                <li>
                  <img src={map} alt="icon" /> Area:
                  <span>Sweden</span>
                </li>
                <li>
                  <img src={cal} alt="icon" /> Type:
                  <span>News update</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="recent_causes_wrapper sidebar_boxed">
            <div class="sidebar_heading_main">
              <h3>Recent news</h3>
            </div>
            {ReceData.map((data, index) => (
              <div class="recent_donet_item" key={index}>
                <div class="recent_donet_img">
                  <Link to="#!">
                    <img src={data.img} alt="img" />
                  </Link>
                </div>
                <div class="recent_donet_text">
                  <div class="sidebar_inner_heading">
                    <h4>
                      <Link to="#!">{data.title}</Link>
                    </h4>
                  </div>
                  <h6>{data.date}</h6>
                </div>
              </div>
            ))}
          </div>
          <div class="share_causes_wrapper sidebar_boxed">
            <div class="sidebar_heading_main">
              <h3>Popular tags</h3>
            </div>
            <div class="popular_tags">
              <ul>
                <li>
                  <Link to="#!">PCF</Link>
                </li>
                <li>
                  <Link to="#!">Education</Link>
                </li>
                <li>
                  <Link to="#!">Children</Link>
                </li>
                <li>
                  <Link to="#!">Badminton</Link>
                </li>
                <li>
                  <Link to="#!">Integration</Link>
                </li>
                <li>
                  <Link to="#!">Culture</Link>
                </li>
                <li>
                  <Link to="#!">Sweden</Link>
                </li>
                <li>
                  <Link to="#!">Community</Link>
                </li>
              </ul>
            </div>
          </div>
          <div class="share_causes_wrapper sidebar_boxed">
            <div class="sidebar_heading_main">
              <h3>Share this story</h3>
            </div>
            <div class="social_icon_sidebar">
              <ul>
                <li>
                  <Link to="#">
                    <img src={facebook} alt="icon" />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <img src={instagram} alt="icon" />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <img src={twitter} alt="icon" />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <img src={linkedin} alt="icon" />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsSidebar;
